import React from 'react'
import { useState,useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import useWhitelist from './use-whitelist';
import {fetchDomesticInternationalShippingServices} from "../actions/shipping"

export default function useShippingServices() {
  const { whitelist, fetchWhitelist } = useWhitelist();
  const dispatch = useDispatch();
  const domesticShippingServices = useSelector((state) => state.global.domesticShippingServices);
  const internationalServices = useSelector((state) => state.global.internationalServices);
  const actions = {
    fetchShippingServices: () => dispatch(fetchDomesticInternationalShippingServices(dispatch)),
  };

    useEffect(() => {
        if(whitelist==true){
          if(domesticShippingServices?.length==0){
            actions.fetchShippingServices()
          }
        }
      }, [whitelist,domesticShippingServices?.length,domesticShippingServices,internationalServices,internationalServices?.length])

    return { domesticShippingServices,internationalServices,...actions };
}
